<script>
  import Grid from "$lib/components/Grid.svelte";
  import Markdown from "$lib/components/Markdown.svelte";

  export let captions;
  export let columns;

  let captionIsTruncated = [];
  let fullCaptionRevealed = [];

  const onResize = (node, callback) => {
    const resizeObserver = new ResizeObserver(() => callback());
    resizeObserver.observe(node);
  };

  function doCaptionTruncation(node) {
    // caption IDs are structured as `imageGridCaption-${index}` where index represents a caption in an img group
    let id = node.id.split("-");
    onResize(node, function () {
      captionIsTruncated[id[1]] = node.offsetHeight < node.scrollHeight;
    });
  }

  function calculateRow(index) {
    const rows = Math.ceil(captions.length / columns.md);

    if (index + 1 > rows * columns.md - columns.md) {
      return "md:pb-0";
    } else {
      return "md:pb-24";
    }
  }
</script>

<div class="sm:mx-24 md:mx-72 sm:my-40 md:my-32 border-l-2 border-neutral-300" aria-label="caption">
  <Grid {columns}>
    {#each captions as caption, index}
      {#if caption}
        <div
          class="flex flex-row gap-x-4 px-12 pb-24 last-of-type:pb-0 {calculateRow(
            index
          )} text-size-14 leading-6 text-neutral-900"
        >
          {#if captions.length > 1}
            <div class="font-bold">
              {index + 1}.
            </div>
          {/if}
          {#if captions.length != 6 && captions.length != 4}
            <div id={`imageGridCaption-${index}`} data-testid={`imageGridCaption-${index}`}>
              <Markdown input={caption} />
            </div>
          {:else}
            <!-- handle 6 and 4 caption truncation for mobile -->
            <div>
              <div
                id={`imageGridCaption-${index}`}
                data-testid={`imageGridCaption-${index}`}
                use:doCaptionTruncation
                class:line-clamp-none={fullCaptionRevealed[index]}
                class="line-clamp-5 md:!line-clamp-none"
              >
                <Markdown input={caption} />
              </div>
              {#if captionIsTruncated[index] || fullCaptionRevealed[index]}
                <button
                  class="btn-link -ml-8 md:hidden"
                  on:click={() => (fullCaptionRevealed[index] = !fullCaptionRevealed[index])}
                >
                  {#if !fullCaptionRevealed[index]}
                    See More
                  {:else}
                    See Less
                  {/if}
                </button>
              {/if}
            </div>
          {/if}
        </div>
      {/if}
    {/each}
  </Grid>
</div>
